declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Empuja un evento a la capa de datos de Google Tag Manager.
 *
 * Se usa en enlaces que se van de la página (WhatsApp, teléfono): al disparar
 * el evento en el `onClick` la etiqueta de conversión de Google Ads se registra
 * antes de que el navegador siga el enlace, así no se pierde la medición.
 */
export function trackEvent(event: string, params: Record<string, unknown> = {}): void {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event, ...params });
}
